import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-meter",
  "use": "dv-meter-usage",
  "viewBox": "0 0 18.37 20",
  "content": "<symbol viewBox=\"0 0 18.37 20\" id=\"dv-meter\"><title>dv-meter</title><path d=\"M18.21,0H1.79a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1H18.21a1,1,0,0,0,1-1V1A1,1,0,0,0,18.21,0ZM6.59,18.54a.73.73,0,1,1,.73-.73A.73.73,0,0,1,6.59,18.54Zm3.37,0a.73.73,0,1,1,.73-.73A.73.73,0,0,1,10,18.54Zm1.89-7.09c-1,1.26-1.94,2.51-2.91,3.77-.07.09-.16.2-.29.12s-.05-.21,0-.31c.29-.8.58-1.6.89-2.39.11-.27,0-.37-.24-.36a4.38,4.38,0,0,1-.78,0c-.29,0-.44-.21-.32-.52.38-1,.76-2,1.15-3,.16-.42.54-.21.79-.27h.3c.57,0,.66.15.46.69s-.31.81-.45,1.22-.19.52.35.53c.26,0,.52,0,.78,0S12.09,11.13,11.85,11.45Zm1.48,7.09a.73.73,0,1,1,.73-.73A.73.73,0,0,1,13.33,18.54ZM16.5,6.44a.93.93,0,0,1-.93.93H4.43a.93.93,0,0,1-.93-.93V2.94A.93.93,0,0,1,4.43,2H15.57a.93.93,0,0,1,.93.93Z\" transform=\"translate(-0.81)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-meter.svg
// module id = yeUM
// module chunks = 264